module.exports = __webpack_public_path__ + "/media/images/news-all-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/news-all-bg.jpg
// module id = 53
// module chunks = 7